function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-64.000000, -524.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(52.000000, 438.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.8629118,11.0674719 L14.8897941,9.94723665 C16.6635,10.5073543 18.7172647,10.1339425 20.1175588,8.73364842 C21.5178529,7.3333543 22.1713235,5.46629548 21.4245,3.59923665 L17.8770882,7.14664842 L14.7030882,3.87929548 L18.2505,0.331883713 C16.2900882,-0.414939817 14.4230294,0.14517783 12.9293824,1.54547195 C11.5290882,2.94576607 11.1556765,4.90617783 11.6224412,6.67988371 L9.84873529,8.45358959 L6.58138235,5.18623665 L5.92791176,3.22582489 L2.00708824,0.611942536 L0.0466764706,2.5723543 L2.66055882,6.58653077 L4.62097059,7.24000136 L7.88832353,10.5073543 L0.700147059,17.6955308 C-0.233382353,18.6290602 -0.233382353,20.1227072 0.700147059,21.0562367 C1.63367647,21.9897661 3.12732353,21.9897661 3.9675,21.0562367 L10.5022059,14.5215308 L16.4767941,20.5894719 L19.7441471,17.322119 L13.8629118,11.0674719 Z M17.2236176,21.0562367 C18.1571471,21.9897661 19.6507941,21.9897661 20.4909706,21.0562367 C21.4245,20.1227072 21.4245,18.6290602 20.4909706,17.7888837 L17.2236176,21.0562367 Z",
  id: "Shape"
}))))));

const SvgIcTools = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTools, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-tools.4d1a1a79.svg";
export { ForwardRef as ReactComponent };